import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <g transform="matrix(.81356 0 0 .81356 0 3.4576)" fill="currentColor">
    <path d="m28.5 11h-1l-2.24-5.38c-0.16-0.38-0.52-0.62-0.93-0.62h-2.83v-1c0-0.55-0.45-1-1-1h-15c-0.55 0-1 0.45-1 1v13c0 0.55 0.45 1 1 1h1c0-2.21 1.79-4 4-4s4 1.79 4 4h5c0-2.21 1.79-4 4-4s4 1.79 4 4h1c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zm-7 0v-4h2.15c0.21 0 0.4 0.13 0.47 0.32l1.38 3.68z" />
    <path d="m10.5 15c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" />
    <path d="m23.5 15c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" />
    <path
      d="m5.5 0h8c0.552 0 1 0.448 1 1s-0.448 1-1 1h-8c-0.552 0-1-0.448-1-1s0.448-1 1-1z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
    <path
      d="m2.5 1c0 0.552-0.448 1-1 1h-0.5c-0.552 0-1-0.448-1-1s0.448-1 1-1h0.5c0.552 0 1 0.448 1 1z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
  </g>
);

const Icon = createSvgIcon(svg, 'TruckFill');

export default Icon;
